import { ANSWER_LABELS, ANSWER_ORDER } from "./goingOutLabels";
import type { GoingOutStatus } from "../../data/types";

type GoingOutPickerProps = {
  current: GoingOutStatus | null;
  disabled?: boolean;
  onAnswer: (status: GoingOutStatus) => void;
  onCancel: () => void;
};

/**
 * De tre svaren.
 *
 * En komponent och inte tre kopior: väljaren finns på kartan, i menyn
 * bakom avataren och på den egna profilen. Låg den i varje komponent
 * skulle "Not tonight is private" kunna sluta stå på ett av ställena —
 * och det är den enda meningen som förklarar vad det tredje svaret gör.
 */
export default function GoingOutPicker({
  current,
  disabled = false,
  onAnswer,
  onCancel,
}: GoingOutPickerProps) {
  return (
    <>
      <div className="going-out-switch" role="group" aria-label="Going out tonight?">
        {ANSWER_ORDER.map((status) => (
          <button
            key={status}
            type="button"
            className={`going-out-chip going-out-chip--option ${
              current === status ? "is-current" : ""
            }`}
            onClick={() => onAnswer(status)}
            disabled={disabled}
            aria-pressed={current === status}
          >
            {ANSWER_LABELS[status]}
          </button>
        ))}

        <button type="button" className="going-out-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>

      {/* Den enda skillnaden mellan det tredje svaret och de två andra,
          sagd rakt ut. Syns bara medan man väljer. */}
      <p className="going-out-fineprint">"Not tonight" is private.</p>
    </>
  );
}
